import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail, LOGO_URL } from "../lib/api";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm(prev => ({ ...prev, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form);
      toast.success("Account created");
      navigate("/account");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Could not register");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-5 py-16" data-testid="register-page">
      <div className="text-center mb-8">
        <img src={LOGO_URL} alt="Aethel Decor — Beyond Decor. Simply Elevated." className="h-16 mx-auto" />
        <h1 className="mt-5 text-3xl text-primary font-medium">Create your account</h1>
        <p className="mt-2 text-sm text-muted-foreground">Save your details & track orders easily</p>
      </div>
      <form onSubmit={submit} className="space-y-5">
        <label className="block">
          <span className="text-xs uppercase tracking-[0.12em] text-muted-foreground">Full name</span>
          <input type="text" value={form.name} onChange={set("name")} required className="mt-1.5 w-full bg-muted px-4 py-3 text-sm outline-none focus:ring-1 focus:ring-primary" data-testid="register-name" />
        </label>
        <label className="block">
          <span className="text-xs uppercase tracking-[0.12em] text-muted-foreground">Email</span>
          <input type="email" value={form.email} onChange={set("email")} required className="mt-1.5 w-full bg-muted px-4 py-3 text-sm outline-none focus:ring-1 focus:ring-primary" data-testid="register-email" />
        </label>
        <label className="block">
          <span className="text-xs uppercase tracking-[0.12em] text-muted-foreground">Phone</span>
          <input type="tel" value={form.phone} onChange={set("phone")} className="mt-1.5 w-full bg-muted px-4 py-3 text-sm outline-none focus:ring-1 focus:ring-primary" data-testid="register-phone" />
        </label>
        <label className="block">
          <span className="text-xs uppercase tracking-[0.12em] text-muted-foreground">Password</span>
          <input type="password" value={form.password} onChange={set("password")} required className="mt-1.5 w-full bg-muted px-4 py-3 text-sm outline-none focus:ring-1 focus:ring-primary" data-testid="register-password" />
        </label>
        <button
          type="submit"
          disabled={loading}
          className="w-full bg-primary text-primary-foreground py-4 text-sm tracking-wide flex items-center justify-center gap-2 disabled:opacity-60"
          data-testid="register-submit"
        >
          {loading && <Loader2 size={18} className="animate-spin" />} Create Account
        </button>
      </form>
      <p className="mt-6 text-center text-sm text-muted-foreground">
        Already have an account?{" "}
        <Link to="/login" className="text-primary font-semibold link-underline" data-testid="to-login">
          Login
        </Link>
      </p>
    </div>
  );
}
